import React from "react";
import Documents from "./AgencyDocuments/AgencyDocuments";
import Budget from "./AgencyBudget/AgencyBudget";
import { Button } from "rsuite";

import AgencyMainModal from "./AgencyMainModal/AgencyMainModal";
import "./AgencyModal.scss";
import {
  Container,
  Sidenav,
  Nav,
  Dropdown,
  Content,
  Sidebar,
  Icon
} from "rsuite";

class AgencyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: "basic_info",
      showSmallModal: false
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  componentDidMount() {
    window.onpopstate = e => {
      this.props.closeModalHandler();
    };
  }

  toggle() {
    this.setState(prevState => ({
      showSmallModal: !prevState.showSmallModal
    }));
  }

  close() {
    this.setState({ showSmallModal: false });
  }

  open() {
    this.setState({ showSmallModal: true });
  }
  render() {
    let role = localStorage.getItem("project_role");
    let shownItem = this.props.agencyItems.find(
        a => a.agency_id === this.props.currentAgencyID
    );
    let disabled = true;
    if (shownItem) {
      disabled = (this.props.mode === 3 && (role !== "ROLE_MEMBER" &&
          shownItem.created_by !== localStorage.getItem("id"))) ||
          this.props.mode === 2;
    }else{
      disabled = false;
    }

    const tabs = [
      <AgencyMainModal
        closed={this.props.closeModalHandler}
        mode={this.props.mode}
        agencyItems={this.props.agencyItems}
        shownItem={shownItem}
        disabled={disabled}
        submit={this.props.submit}
      />,
      <Documents
        currentAgencyID={this.props.currentAgencyID}
        getAgencyDocuments={this.props.getAgencyDocuments}
        documents={this.props.documents}
        addDocuments={this.props.addDocuments}
        close={this.close}
        open={this.open}
        toggleSmallModalHandler={this.props.toggleSmallModalHandler}
        showSmallModal={this.state.showSmallModal}
        disabled={disabled}
      />,
      <Budget
        currentAgencyID={this.props.currentAgencyID}
        fetchBudget={this.props.fetchBudget}
        budget={this.props.budget.filter(
          a => a.agency_id === this.props.currentAgencyID
        )}
        toggleSmallModalHandler={this.props.toggleSmallModalHandler}
        showSmallModal={this.props.showSmallModal}
        addBudget={this.props.addBudget}
        updateBudget={this.props.updateBudget}
        deleteBudget={this.props.deleteBudget}
        disabled={disabled}
      />
    ];
    let mainBody = tabs[0];

    if (this.state.currentTab === "basic_info") {
      mainBody = tabs[0];
    } else if (this.state.currentTab === "budget") {
      mainBody = tabs[2];
    } else {
      mainBody = React.cloneElement(tabs[1], {
        tab_id:
          this.state.currentTab === "doc_pictures"
            ? 0
            : this.state.currentTab === "doc_videos"
            ? 1
            : 2
      });
    }

    return (
      <div className="AgencyModal">
        <Container>
          <Sidebar
            style={{ display: "flex", flexDirection: "column" }}
            collapsible
            className="mx-2"
          >
            <Button onClick={this.props.closeModalHandler}>
              <b>
                <Icon size={"1x"} icon="arrow-circle-o-left" /> Back to Agency
                List
              </b>
            </Button>
            <Sidenav
              defaultOpenKeys={["3"]}
              defaultActiveKey="2"
              style={{ display: "flex", flexDirection: "column" }}
              collapsible
              appearance="subtle"
              onSelect={eventKey => {
                this.setState({
                  currentTab: eventKey
                });
              }}
            >
              <Sidenav.Body>
                <Nav>
                  <Nav.Item
                    eventKey="basic_info"
                    icon={<Icon icon="dashboard" />}
                  >
                    Basic Information
                  </Nav.Item>
                  <Dropdown
                    icon={<Icon icon="file" />}
                    eventKey="documents"
                    title="Files"
                    disabled={this.props.mode !== 3}
                  >
                    <Dropdown.Item
                      className="mx-3"
                      eventKey="doc_others"
                      onClick={this.close}
                      disabled={this.props.mode !== 3}
                    >
                      Documents
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="mx-3"
                      eventKey="doc_pictures"
                      onClick={this.close}
                      disabled={this.props.mode !== 3}
                    >
                      Logo
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="mx-3"
                      eventKey="doc_videos"
                      onClick={this.close}
                      disabled={this.props.mode !== 3}
                    >
                      Videos
                    </Dropdown.Item>
                  </Dropdown>
                  <Nav.Item
                    disabled={this.props.mode !== 3}
                    eventKey="budget"
                    icon={<Icon icon="money" />}
                  >
                    Budget
                  </Nav.Item>
                </Nav>
              </Sidenav.Body>
            </Sidenav>
          </Sidebar>

          <Container>
            <Content>{mainBody}</Content>
          </Container>
        </Container>
      </div>
    );
  }
}

export default AgencyModal;
